import i18nProvider from './index';

/**
 * Tradução fora do react-admin, usada pelo plugin de build
 * (scripts/i18n/babel-plugin-i18n-wrap.mjs), que embrulha automaticamente texto de
 * JSX e props de texto: `<Typography>Olá</Typography>` vira `{__t('Olá')}`.
 *
 * Em pt-br devolve o próprio texto. Em espanhol procura no catálogo
 * (messages/es/catalog) e, sem entrada lá, devolve o português.
 *
 * Dá para chamar à mão quando o texto não está em JSX:
 *   __t('Cliente %{nome} bloqueado', { nome })
 */
export const __t = (text: string, args?: Record<string, unknown>): string =>
    i18nProvider.translate(text, args ? { _: text, ...args } : { _: text });

export default __t;
